export function normalize<T extends { id: string | number }>(items: T[]): Dictionary<T> {
  return items.reduce((acc, item) => {
    Object.assign(acc, { [item.id]: item })
    return acc
  }, {})
}
